import React from 'react'
import { Container } from '../atoms'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export const ContainerCreditApplication = ({ style, ...props }) => (
  <Container
    minified
    style={composeStyle({ paddingHorizontal: 32 }, style)}
    {...props}
  />
)
